import { supabase, updateSupabaseSession } from "../utils/supabaseClient";

/**
 * Hard-activate / hard-deactivate a staff account.
 *
 * RPC: ehealth.api2_set_staff_active (provisioned in vrijmetse/service-clinic
 * PR #1, applied to staging + preprod). Deactivation sets
 * ehealth.jhi_user.activated = false, and a DB trigger mirrors it to
 * auth.users.banned_until = '3000-01-01', blocking BOTH the Spring Boot and
 * Supabase Auth login paths.
 *
 * The RPC enforces its own guards: ROLE_OWNER, same business, no self-
 * deactivation, last-active-owner protection. Errors are surfaced verbatim.
 */
export const setStaffActive = async (staffId, active) => {
  try {
    await updateSupabaseSession();
    const { data, error } = await supabase
      .schema("ehealth")
      .rpc("api2_set_staff_active", {
        p_staff_id: staffId,
        p_active: active,
      });

    if (error) {
      return { error, status: 500 };
    }
    return { data, status: 200 };
  } catch (err) {
    return { error: err, status: 500 };
  }
};
